import { Location, History } from "history";
import { isString } from "lodash";

import { testerAccountPaths, websiteContentPaths } from "configuration/app_paths";
import { ErrorData } from "types/app";

type ErrorHandlerProps = { history: History; location: Location };

const FORBIDDEN_RESPONSE_STATUS = 403;

const customErrorHandler = (props: ErrorHandlerProps) => (error: ErrorData) => {
  if (isString(error)) return;

  if (error.error && error.code === "check_up_verification_failed") {
    redirectToCheckupVerificationPage(props);
  } else if (error.status === FORBIDDEN_RESPONSE_STATUS) {
    redirectToErrorPage(props);
  }
};

export default customErrorHandler;

function redirect(props: ErrorHandlerProps, onHistoryAvailable: () => void, fallbackPath: string) {
  if (props.history) {
    onHistoryAvailable();
  } else {
    // Missing router props fallback
    window.location.href = fallbackPath;
  }
}

function redirectToCheckupVerificationPage(props: ErrorHandlerProps) {
  redirect(
    props,
    () => {
      const location = props.location;

      props.history.push({
        pathname: testerAccountPaths.checkUpVerification,
        state: {
          query: {
            url: location ? location.pathname : testerAccountPaths.dashboard,
          },
        },
      });
    },
    testerAccountPaths.checkUpVerification,
  );
}

function redirectToErrorPage(props: ErrorHandlerProps) {
  const errorPagePath = websiteContentPaths.error;

  redirect(
    props,
    () => {
      props.history.push({ pathname: errorPagePath });
    },
    errorPagePath,
  );
}
